import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import IllustrationIcon from "../../Images/Svg/IllustrationIcon.svg";
import { useSelector } from "react-redux";

const Illustration = () => {
  const { username } = useSelector((state) => state.loginSlice.userData);
  const { activeTourStep } = useSelector((state) => state.appTourSlice);
  const isTourActive =
    activeTourStep === 1
      ? {
          background: "white",
          padding: "10px",
          minHeight: "160px",
          boxShadow: "0px 2px 10px 0px #FFFFFFB2",
          borderRadius: "20px",
          border: "1px solid #9F9F9F",
        }
      : {};

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%%",
        height: "12.2rem",
        ml: { sx: "0", sm: "2.4rem", md: "2.4rem" },
        mt: { sx: "0", sm: "2.4rem", md: "2.4rem" },
        ...isTourActive,
      }}
      id="illustration"
    >
      <Box sx={{ display: "block", width: "100%" }}>
        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              fontSize: "2rem",
              lineHeight: "2.4rem",
              color: "#E42125",
              display: { xs: "none", sm: "block", md: "block" },
            }}
          >
            Case Investigation Management Application
          </Typography>
        </Box>
        <Box
          sx={{
            background: {
              xs: "none",
              sm: `linear-gradient(90.43deg, #F3FAFC 49.63%, rgba(243, 250, 252, 0) 95.72%)`,
              md: `linear-gradient(90.43deg, #F3FAFC 49.63%, rgba(243, 250, 252, 0) 95.72%)`,
            },
            borderRadius: "1rem",
            width: "100%",
            height: "8.6rem",
            mt: "1.2rem",
            marginLeft: { xs: "2.2rem", sm: "0", md: "0", lg: "0" },
            p: { xs: "0", sm: 2, md: 2 },

            alignItems: "center", // Center the content vertically
          }}
        >
          <Typography
            sx={{
              fontWeight: 500,
              fontSize: "1.8rem",
              lineHeight: "2.2rem",
              alignItems: "center",
              mt: "0.5rem",
              color: { xs: "#E94D51", md: "#3A3A3A" },
            }}
          >
            Welcome {username}!
          </Typography>
          <Typography
            sx={{
              fontWeight: 400,
              fontSize: "1.5rem",
              lineHeight: "1.8rem",
              color: "#666666",
              mt: "0.5rem",
              alignItems: "center",
            }}
          >
            Now access your cases, vendors and reports through your personalized
            CHASE Dashboard!
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: { xs: "none", md: "block" } }}>
        <img src={IllustrationIcon} alt="illustration-dashboard" />
      </Box>
    </Box>
  );
};

export default Illustration;
